const colorVars = {
  lightGray: 'rgb(233, 233, 233)',
}

const smsPreviewWrapper = {
  minHeight: 0,
}

const smsPreviewArrow = {
  height: '9px',
  width: '13px',
  background: colorVars.lightGray,
  display: 'block',
  margin: '-5px 8px 0 0',
  borderRadius: '0 0 100% 0',
  transform: 'rotate(60deg)',
  zIndex: '1',
  float: 'right',
}

const smsImage = {
  background: colorVars.lightGray,
  borderRadius: '12px 12px 0 0',
  marginTop: '16px',
  padding: '16px 16px 0 16px',
  marginBottom: '-1px',
}

const smsImageBase = () => ({
  background: colorVars.lightGray,
  img: {
    borderRadius: '8px',
  },
})

const getSmsPreview = (hasAsset) => ({
  backgroundColor: colorVars.lightGray,
  borderRadius: hasAsset ? '0 0 12px 12px' : '12px',
  padding: '11px 16px',
  width: 'calc(100% - 32px)',
  marginTop: hasAsset ? 0 : '16px',
  marginBottom: '3px',
  zIndex: '2',

  '&:hover': {
    backgroundColor: colorVars.lightGray,
  },
})

const styles = {
  smsPreviewWrapper,
  getSmsPreview,
  smsPreviewArrow,
  smsImage,
  smsImageBase,
}

export { styles }
